import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useDeleteProvider = (id: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void>({
    mutationFn: () =>
      dispatch(
        apiThatThrows.deleteTiVoProvider.action({
          params: { id },
        })
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
